'use strict';

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resultMatchesActiveSearchTerms(result, searchTerms) {
  var filtered = true;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = searchTerms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var searchTerm = _step.value;

      if (typeof searchTerm == "function") {
        if (filtered) filtered = searchTerm(result); // custom filter function.
      } else {
        var re = new RegExp(searchTerm, 'i');
        if (!result.Destination.DestinationName.match(re) && !result.Description.match(re) && !(result.DisplayName && result.DisplayName.match(re))) {
          return false;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return filtered;
}

function resultMatchesActiveStarFilters(result, starRatings) {
  if (!starRatings.one && !starRatings.two && !starRatings.three && !starRatings.four && !starRatings.five) {
    return true;
  }
  if (result.Rating == 5 && starRatings.five) {
    return true;
  } else if (result.Rating == 4 && starRatings.four) {
    return true;
  } else if (result.Rating == 3 && starRatings.three) {
    return true;
  } else if (result.Rating == 2 && starRatings.two) {
    return true;
  } else if (result.Rating == 1 && starRatings.one) {
    return true;
  }
  return false;
}

function resultMatchesActiveCriteriaFilters(result, searchCriteriaDefinitions) {
  // console.log('[WDF RMACF] Called:', result, searchCriteriaDefinitions);

  var resultValues = result.CriteriaValues || {};

  var activeFilters = _.pickBy(searchCriteriaDefinitions, filterIsActive);
  // console.log('[WDF RMACF] Active filters:', activeFilters);

  var allMatch = _.every(activeFilters, function (def, key) {
    var userValue = def.filterVal;
    var resultValue = resultValues[key] && resultValues[key].Value;
    if (resultValue === undefined) {
      console.warn('[WDF RMACF] Result has no value for criteria', key, '- hiding result. Result:', result);
      // Should a result be shown or hidden if it has no value for the criteria?
      // Alternatively, should the decision be moved to resultMatchesFilter and made
      // based on the type of the filter?
      // Hide the result for now.
      return false;
    }
    var isMatch = resultMatchesFilter(def, userValue, resultValue);
    // logSingleFilterResult(key, userValue, resultValue, isMatch); // Uncomment for logging
    return isMatch;
  });

  // logAllFiltersResult(result, allMatch); // Uncomment for logging

  return allMatch;
}

function resultMatchesActiveRegion(result, regions) {
  if (regions == null) {
    return true;
  }

  // Show all results if all regions are checked.
  // if (_.every(regions, region => region.value === true)) {
  //     return true;
  // }

  var activeRegions = _.filter(regions, function (region) {
    return region.value === true;
  });

  // Show all results if none of the regions are checked.
  if (activeRegions.length === 0) {
    return true;
  }

  // if (activeRegions.length === 0) {
  //   // Show (faulty) results with no region.
  //   return !result.Destination.SubGroup;
  // }

  // Filter by checked regions.
  return _.some(activeRegions, function (region) {
    return region.code === result.Destination.SubGroup;
  });
}

function filterIsActive(filterDef) {
  // NOTE: This currently assumes that a filter value of null means the filter is inactive.
  return filterDef.filterVal !== undefined && filterDef.filterVal !== null && filterDef.filterVal !== false; // Fix check + uncheck filtering some products incorrectly.
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function resultMatchesFilter(filterDef, userValue, resultValue) {
  switch (filterDef.Type) {
    case 'Boolean':
      return !userValue || resultValue; // resultValue only matters when userValue is true

    case 'Select':
      return resultValue === userValue;

    case 'Number':
      // Range filter.
      if (!isNumber(resultValue)) return true; // Is not number.
      //resultValue = Number(resultValue);
      var min = userValue.min;
      var max = userValue.max;
      if (min == undefined && max == undefined) return true; // optional min and max.
      if (min && max == undefined) return resultValue >= min; // optional max.
      if (min == undefined && max) return resultValue <= max; // optional min.
      return resultValue >= min && resultValue <= max;

    default:
      console.warn('[WDF RMF] Unknown filter type', filterDef.Type, 'for filter:', filterDef);
      // Fail-safe: Act as though the unknown filter had passed.
      return true;
  }
}

function resultMatchesBeds(result, numAdults, numChildren) {
  var beds = 0;
  var extraBeds = 0;
  var totalBeds = 0;
  if (result.Product !== null) {
    beds = result.Product.DestinationInfo.Beds;
    extraBeds = result.Product.DestinationInfo.ExtraBeds;
    totalBeds = beds + extraBeds;
  } else beds = result.Capacity.Available;

  if (!beds) return true;
  if (!numAdults && !numChildren) return true;

  var numPeople = numAdults + numChildren;

  if (result.Product === null) return numPeople <= beds;

  if (result.Product.DestinationInfo.AdultExtraBedsAllowed && result.Product.DestinationInfo.ChildExtraBedsAllowed) {
    if (numPeople <= totalBeds) return true;
  } else if (result.Product.DestinationInfo.AdultExtraBedsAllowed) {
    if (numChildren <= beds && numPeople <= totalBeds) return true;
  } else if (result.Product.DestinationInfo.ChildExtraBedsAllowed) {
    if (numAdults <= beds && numPeople <= totalBeds) return true;
  }
  return numPeople <= beds;
}

function logSingleFilterResult(key, userValue, resultValue, isMatch) {
  console.log('[WDF RMACF] Filter', key, '(', userValue, ',', resultValue, ') =', isMatch ? 'pass' : 'FAIL');
}

function logAllFiltersResult(result, allMatch) {
  var dest = result.Destination.DestinationCode;
  var something = result.Product || result.Departure;
  var di = something.DestinationInfo;
  var prod = di.ProductCode || '<no product code>';
  var date = moment(result.StartDate).format('YYYY-m-d');
  console.log('[WDF RMACF] Result (', dest, prod, date, ') =', allMatch ? 'pass' : 'FAIL');
}

// Custom filter for filtering results already loaded from backend, using combinedFilters object
_module3.default.filter('combinedFilter', function () {
  return function (results, combinedFilters) {
    if (!results) {
      return null;
    }
    return results.filter(function (result) {
      //console.log(result);

      if (result.Product != null) {
        return resultMatchesActiveSearchTerms(result, combinedFilters.searchTerms) && resultMatchesActiveCriteriaFilters(result, combinedFilters.searchCriteriaDefinitions) && resultMatchesActiveStarFilters(result, combinedFilters.starRatings) && resultMatchesActiveRegion(result, combinedFilters.regions) && (
        //resultMatchesBeds(result, combinedFilters.numAdults, combinedFilters.numChildren) &&
        !combinedFilters.priceRange.min || result.Price >= combinedFilters.priceRange.min - 1) && (!combinedFilters.priceRange.max || result.Price <= combinedFilters.priceRange.max) && (!combinedFilters.duration.startDate || moment(result.StartDate).isSameOrAfter(combinedFilters.duration.startDate, 'day')) && (!combinedFilters.duration.endDate || moment(result.EndDate).isSameOrBefore(combinedFilters.duration.endDate, 'day')); /*&&
                                                                                                                                                                                                                                                                                                                                                                                                                                              ((!combinedFilters.numOfBeds || !result.Product.DestinationInfo.Beds) || result.Product.DestinationInfo.Beds >= combinedFilters.numOfBeds);*/
      }
      return resultMatchesActiveSearchTerms(result, combinedFilters.searchTerms) && resultMatchesActiveCriteriaFilters(result, combinedFilters.searchCriteriaDefinitions) && resultMatchesActiveStarFilters(result, combinedFilters.starRatings) && resultMatchesActiveRegion(result, combinedFilters.regions) && (
      //resultMatchesBeds(result, combinedFilters.numAdults, combinedFilters.numChildren) &&
      !combinedFilters.priceRange.min || result.Price >= combinedFilters.priceRange.min - 1) && (!combinedFilters.priceRange.max || result.Price <= combinedFilters.priceRange.max) && (!combinedFilters.duration.startDate || moment(result.StartDate).isSameOrAfter(combinedFilters.duration.startDate, 'day')) && (!combinedFilters.duration.endDate || moment(result.EndDate).isSameOrBefore(combinedFilters.duration.endDate, 'day')); /*&&
                                                                                                                                                                                                                                                                                                                                                                                                                                            ((!combinedFilters.numOfBeds || !result.Capacity.Available) || result.Capacity.Available >= combinedFilters.numOfBeds);*/
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/filters/searchFilter.js
// module id = 509
// module chunks = 2